import {useState} from 'react';
import {commitTicketingMutation} from '../../../graphql/forecastRelay';
import UpdateAutoReplyMutation from '../../../../../mutations/ticketing/admin/useUpdateAutoReplyMutation';

export interface UpdateAutoReplyInput {
	enabled: boolean;
	fromName: string;
	fromEmail: string;
	bodyHtml: string;
}

export function useUpdateAutoReply() {
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState<string | null>(null);

	function update(input: UpdateAutoReplyInput): Promise<void> {
		setError(null);
		setLoading(true);
		return new Promise((resolve, reject) => {
			commitTicketingMutation(
				UpdateAutoReplyMutation,
				input,
				() => {
					setLoading(false);
					resolve();
				},
				err => {
					setLoading(false);
					const msg = err instanceof Error ? err.message : String(err);
					setError(msg);
					reject(err);
				}
			);
		});
	}

	return {update, loading, error, setError};
}
